module.exports = __webpack_public_path__ + "img/youtube.png.3ab6d224.webp";